import { GET } from './httpMethods';

const getOcrRib = (contractId) => GET(`/api/contracts/${contractId}/extractIban`).then((response) => response.json());

export default getOcrRib;
